// extracted by mini-css-extract-plugin
export var isPrintedCell = "_x6-1";
export var printerIcon = "_x6-0";